import React from 'react';
import PropTypes from 'prop-types';

export const HealthChartTooltip = ({ 
  name, 
  lastUpdate, 
  percentage, 
  updatedProducts, 
  totalProducts, 
  color 
}) => {
  if (!name) return null;
  
  const formattedDate = lastUpdate || '-';
  const tooltipStyle = {
    minWidth: '200px',
    padding: '4px',
    fontSize: '12px',
    lineHeight: '1.4',
    color: '#333'
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
    fontWeight: '600'
  };

  const indicatorStyle = {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: color
  };

  const infoStyle = {
    marginBottom: '4px',
    color: '#555'
  };

  const lastInfoStyle = {
    ...infoStyle,
    marginBottom: 0
  };

  return (
    <div style={tooltipStyle} data-testid="health-chart-tooltip">
      <div style={headerStyle}>
        <div style={indicatorStyle} />
        <strong>{name}</strong>
      </div>
      <div style={infoStyle}>
        Última actualización:{' '}{formattedDate}
      </div>
      <div style={infoStyle}>
        <strong>{percentage}% de actualización</strong>
      </div>
      <div style={lastInfoStyle}>
        {updatedProducts.toLocaleString()} / {totalProducts.toLocaleString()} productos
      </div>
    </div>
  );
};

HealthChartTooltip.propTypes = {
  name: PropTypes.string,
  lastUpdate: PropTypes.string,
  percentage: PropTypes.number,
  updatedProducts: PropTypes.number,
  totalProducts: PropTypes.number,
  color: PropTypes.string
};

export default HealthChartTooltip;